import { useEffect, useState } from "react";
import { Aviso, Panel } from "../componentes/piezas";
import { useIdioma } from "../lib/idioma";
import {
  activar,
  desactivar,
  enviarPrueba,
  estadoActual,
  type EstadoAvisos,
} from "./avisos";

/** Interruptor de los avisos del club, con el estado real del navegador. */
export default function PortalAvisos() {
  const { t } = useIdioma();
  const [estado, setEstado] = useState<EstadoAvisos | null>(null);
  const [trabajando, setTrabajando] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    void estadoActual().then(setEstado);
  }, []);

  async function alternar() {
    setTrabajando(true);
    setError("");
    setMensaje("");
    try {
      if (estado === "activados") {
        await desactivar();
        setEstado("sin-activar");
        setMensaje(t("avisos.yaNo"));
      } else {
        const nuevo = await activar();
        setEstado(nuevo);
        if (nuevo === "activados") setMensaje(t("avisos.listo"));
        else if (nuevo === "bloqueados") setError(t("avisos.bloqueados"));
      }
    } catch {
      setError(t("avisos.fallo"));
    } finally {
      setTrabajando(false);
    }
  }

  if (estado === null) return null;

  return (
    <Panel titulo={t("avisos.titulo")}>
      <Aviso tipo="error">{error}</Aviso>
      <Aviso tipo="ok">{mensaje}</Aviso>

      {estado === "no-soportado" ? (
        <p className="suave" style={{ margin: 0 }}>
          {t("avisos.noSoportado")}
        </p>
      ) : estado === "requiere-instalar" ? (
        <p className="suave" style={{ margin: 0 }}>
          {t("avisos.requiereInstalar1")}{" "}
          <strong>{t("avisos.compartir")}</strong> {t("avisos.yLuego")}{" "}
          <strong>{t("avisos.anadirAInicio")}</strong>.{" "}
          {t("avisos.requiereInstalar2")}
        </p>
      ) : (
        <>
          <p className="suave" style={{ marginTop: 0 }}>
            {estado === "activados"
              ? t("avisos.activados")
              : t("avisos.sinActivar")}
          </p>
          <div className="fila ajustable">
            <button
              className={`boton ${estado === "activados" ? "secundario" : ""}`}
              disabled={trabajando || estado === "bloqueados"}
              onClick={alternar}
            >
              {trabajando
                ? t("general.unMomento")
                : estado === "activados"
                  ? t("avisos.desactivar")
                  : t("avisos.activar")}
            </button>

            {estado === "activados" && (
              <button
                className="boton fantasma"
                disabled={trabajando}
                onClick={async () => {
                  setMensaje("");
                  setError("");
                  const enviados = await enviarPrueba().catch(() => 0);
                  if (enviados > 0) setMensaje(t("avisos.pruebaEnviada"));
                  else setError(t("avisos.pruebaFallo"));
                }}
              >
                {t("avisos.enviarPrueba")}
              </button>
            )}
          </div>
        </>
      )}
    </Panel>
  );
}
